module.exports = "/images/ThankyouGradient_v2.png?034f5c90582af2ff70d61519ec221b19";